/*!
* Color mode toggler for CoreUI's docs (https://coreui.io/)
* Copyright (c) 2025 creativeLabs Łukasz Holeczek
* Licensed under the Creative Commons Attribution 3.0 Unported License.
*/

(() => {
  const THEME = 'coreui-free-bootstrap-admin-template-theme'
  const validThemes = new Set(['dark', 'light', 'auto'])
  const systemTheme = window.matchMedia('(prefers-color-scheme: dark)')

  const getStoredTheme = () => {
    try {
      return localStorage.getItem(THEME)
    } catch {
      return null
    }
  }

  const setStoredTheme = theme => {
    try {
      localStorage.setItem(THEME, theme)
    } catch {
      // The selected theme still works when browser storage is unavailable.
    }
  }

  const getPreferredTheme = () => {
    const storedTheme = getStoredTheme()

    if (validThemes.has(storedTheme)) {
      return storedTheme
    }

    // Default: dark tema
    return 'dark'
  }

  const setTheme = theme => {
    const resolvedTheme = theme === 'auto' ? (systemTheme.matches ? 'dark' : 'light') : theme
    document.documentElement.setAttribute('data-coreui-theme', resolvedTheme)

    const event = new Event('ColorSchemeChange')
    document.documentElement.dispatchEvent(event)
  }

  let selectedTheme = getPreferredTheme()
  setTheme(selectedTheme)

  const showActiveTheme = theme => {
    const btnToActive = document.querySelector(`[data-coreui-theme-value="${theme}"]`)
    const svgOfActiveBtn = btnToActive?.querySelector('svg use')?.getAttribute('xlink:href')

    for (const element of document.querySelectorAll('[data-coreui-theme-value]')) {
      const active = element.getAttribute('data-coreui-theme-value') === theme
      element.classList.toggle('active', active)
      element.setAttribute('aria-pressed', String(active))
    }

    if (svgOfActiveBtn) {
      for (const icon of document.querySelectorAll('.theme-icon-active use')) {
        icon.setAttribute('xlink:href', svgOfActiveBtn)
      }
    }
  }

  // Common headers can be inserted or replaced after DOMContentLoaded.
  window.DataRaporTheme = { refresh: () => showActiveTheme(selectedTheme) }

  systemTheme.addEventListener('change', () => {
    if (selectedTheme === 'auto') {
      setTheme(selectedTheme)
    }
  })

  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-coreui-theme-value]')
    const theme = toggle?.getAttribute('data-coreui-theme-value')
    if (!validThemes.has(theme)) {
      return
    }

    selectedTheme = theme
    setStoredTheme(theme)
    setTheme(theme)
    showActiveTheme(theme)
  })

  window.addEventListener('storage', event => {
    if (event.key !== THEME && event.key !== null) {
      return
    }

    selectedTheme = getPreferredTheme()
    setTheme(selectedTheme)
    showActiveTheme(selectedTheme)
  })

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', () => showActiveTheme(selectedTheme))
  } else {
    showActiveTheme(selectedTheme)
  }
})()
